"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleKindTranslations = exports.ROLE_KINDS = exports.generalRoleTranslations = exports.pseudoRoleFilters = exports.ROLES = void 0;
exports.ROLES = {
    // General
    ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
    SURVEY_SCHEMA_ADMIN: 'SURVEY_SCHEMA_ADMIN',
    SURVEY_SCHEMA_PARTS_ADMIN: 'SURVEY_SCHEMA_PARTS_ADMIN',
    EXTRA_QUESTION_ADMIN: 'EXTRA_QUESTION_ADMIN',
    // HUL
    HUL_SURVEY_ADMIN: 'HUL_SURVEY_ADMIN',
    HUL_SURVEY_VIEWER: 'HUL_SURVEY_VIEWER',
    HUL_RESTRICTED_VIEWER: 'HUL_RESTRICTED_VIEWER',
    HUL_PARTICIPANT_VIEWER: 'HUL_PARTICIPANT_VIEWER',
    HUL_DATA_EXPORTER: 'HUL_DATA_EXPORTER',
    HUL_RESTRICTED_DATA_EXPORTER: 'HUL_RESTRICTED_DATA_EXPORTER',
    // HUS
    HUS_SURVEY_ADMIN: 'HUS_SURVEY_ADMIN',
    HUS_SURVEY_VIEWER: 'HUS_SURVEY_VIEWER',
    HUS_RESTRICTED_VIEWER: 'HUS_RESTRICTED_VIEWER',
    HUS_PARTICIPANT_VIEWER: 'HUS_PARTICIPANT_VIEWER',
    HUS_DATA_EXPORTER: 'HUS_DATA_EXPORTER',
    HUS_RESTRICTED_DATA_EXPORTER: 'HUS_RESTRICTED_DATA_EXPORTER',
    // HUT
    HUT_SURVEY_ADMIN: 'HUT_SURVEY_ADMIN',
    HUT_SURVEY_VIEWER: 'HUT_SURVEY_VIEWER',
    HUT_RESTRICTED_VIEWER: 'HUT_RESTRICTED_VIEWER',
    HUT_PARTICIPANT_VIEWER: 'HUT_PARTICIPANT_VIEWER',
    HUT_DATA_EXPORTER: 'HUT_DATA_EXPORTER',
    HUT_RESTRICTED_DATA_EXPORTER: 'HUT_RESTRICTED_DATA_EXPORTER',
    // HUP
    HUP_SURVEY_ADMIN: 'HUP_SURVEY_ADMIN',
    HUP_SURVEY_VIEWER: 'HUP_SURVEY_VIEWER',
    HUP_RESTRICTED_VIEWER: 'HUP_RESTRICTED_VIEWER',
    HUP_PARTICIPANT_VIEWER: 'HUP_PARTICIPANT_VIEWER',
    HUP_DATA_EXPORTER: 'HUP_DATA_EXPORTER',
    HUP_RESTRICTED_DATA_EXPORTER: 'HUP_RESTRICTED_DATA_EXPORTER',
};
exports.pseudoRoleFilters = {
    NO_ROLE: 'NO_ROLE',
    ANY_ROLE: 'ANY_ROLE'
};
exports.generalRoleTranslations = {
    fi: {
        ORGANIZATION_ADMIN: 'Organisaation ylläpitäjä',
        SURVEY_SCHEMA_ADMIN: 'Kyselypohjien hallinnoija',
        SURVEY_SCHEMA_PARTS_ADMIN: 'Osakyselyiden hallinnoija',
        EXTRA_QUESTION_ADMIN: 'Lisäkysymysten hallinnoija'
    },
    sv: {
        ORGANIZATION_ADMIN: 'Organisationens administratör',
        SURVEY_SCHEMA_ADMIN: 'Enkätmallarnas administratör',
        SURVEY_SCHEMA_PARTS_ADMIN: 'Undersökningsdelarnas administratör',
        EXTRA_QUESTION_ADMIN: 'Tilläggsfrågornas administratör'
    },
    en: {
        ORGANIZATION_ADMIN: 'Organisation admin',
        SURVEY_SCHEMA_ADMIN: 'Survey template admin',
        SURVEY_SCHEMA_PARTS_ADMIN: 'Sub-survey admin',
        EXTRA_QUESTION_ADMIN: 'Additional questions manager'
    }
};
exports.ROLE_KINDS = {
    ADMIN: 'ADMIN',
    VIEWER: 'VIEWER',
    RESTRICTED_VIEWER: 'RESTRICTED_VIEWER',
    PARTICIPANT_VIEWER: 'PARTICIPANT_VIEWER',
    DATA_EXPORTER: 'DATA_EXPORTER',
    RESTRICTED_DATA_EXPORTER: 'RESTRICTED_DATA_EXPORTER',
};
exports.roleKindTranslations = {
    fi: {
        ADMIN: 'Kyselyn hallinnoija',
        VIEWER: 'Katselukäyttäjä (laajat oikeudet)',
        RESTRICTED_VIEWER: 'Katselukäyttäjä (suppeat oikeudet)',
        PARTICIPANT_VIEWER: 'Osallistujalistan katseluoikeus',
        DATA_EXPORTER: 'Tutkimuskäyttäjä',
        RESTRICTED_DATA_EXPORTER: 'Vastausten Excel -vienti, anonymisoitu data',
    },
    sv: {
        ADMIN: 'Enkätens administratör',
        VIEWER: 'Användare med läsbehörighet (omfattande behörighet)',
        RESTRICTED_VIEWER: 'Användare med läsbehörighet (begränsad behörighet)',
        PARTICIPANT_VIEWER: 'Läsbehörighet till deltagarlista',
        DATA_EXPORTER: 'Forskningsanvändare',
        RESTRICTED_DATA_EXPORTER: 'Att föra enkäters svar till Excel, anonymiserad data',
    },
    en: {
        ADMIN: 'Survey admin',
        VIEWER: 'Viewing user (broad privileges)',
        RESTRICTED_VIEWER: 'Viewing user (limited privileges)',
        PARTICIPANT_VIEWER: 'Participant list viewing right',
        DATA_EXPORTER: 'Research user',
        RESTRICTED_DATA_EXPORTER: 'Export to Excel of survey responses, anonymised data',
    }
};
